<template>
  <div id="app">
    <!-- <div v-if="opening" id="firework" class="firework">
        <div v-if="fireworkActive" class="timer">{{ count }}</div>
        <div v-else @click="onFirework()" class="timer-btn">Старт</div>
        <div id="pyro" class="pyro">
            <div class="before"></div>
            <div class="after"></div>
            <Firework v-if="fireworkActive" :boxHeight="'100%'" :boxWidth="'100%'"/>
        </div>
    </div> -->
    <transition name="fade">
    <Header :data.sync="data"></Header>
    </transition>
    <transition name="fade">
      <router-view style="min-height: 600px;" :data.sync="data"></router-view>
    </transition>
    <Footer :data.sync="data"></Footer>
  </div>
</template>

<script>
import Header from './components/common/Header.vue'
import Footer from './components/common/Footer.vue'
// import Firework from './components/common/Firework.vue'

export default {
    name: 'App',
    components: {
        Header,
        Footer,
        // Firework
    },
    data(){
        return {
            data: {
                impairedRegime: false,
            }, 
            count: 5,
            fireworkActive: false,
            opening: true
        }
    },
    created(){
        // this.onFirework()
        // if(sessionStorage.getItem('shynOpening')){
        //     this.opening = false
        // } 
        if(!localStorage.getItem('xyzCustomLang')){
            localStorage.setItem('xyzCustomLang', 'kk')
        } 
    },
    mounted(){
        window.lang = 'kk'
        if(localStorage.getItem('xyzCustomLang')){
            window.lang = localStorage.getItem('xyzCustomLang');
        } 
        
    },
    watch:{
        '$route' () {
            if(this.$route.name !== 'faq' && this.$route.name !== 'rubric'){
                window.scrollTo(0,0)
            }
        document.title = this.$route.meta.title + ' | Shyn' || 'Shyn';
        }
    },
    methods: {
        onFirework(){
            sessionStorage.setItem('shynOpening', true)
            this.fireworkActive = true
            this.onCount()
            setTimeout(() => {
                document.getElementById('firework').style.opacity = 0
                document.getElementById('pyro').style.display = 'none'
                setTimeout(() => {
                    document.getElementById('firework').style.display = 'none'
                }, 1000)
            }, 5000)
        },
        onCount(){
            setTimeout(() => {
                this.count -= 1
                if( this.count <= 0 ) return
                this.onCount()
            }, 1000)
        }
    }
}
</script>

<style lang="scss">
@font-face {
  font-family: Gilroy;
  font-display: swap;
  src: url('../src/assets/font/Gilroy/Gilroy-Light.ttf');
}
@font-face {
  font-family: Commissioner;
  font-display: swap;
  src: url('../src/assets/font/Commissioner/static/Commissioner-Light.ttf');
}
@font-face {
  font-family: Gilroy-Medium;
  font-display: swap;
  src: url('../src/assets/font/Gilroy/Gilroy-Medium.ttf');
}
@font-face {
  font-family: Jersey;
  font-display: swap;
  src: url('../src/assets/font/JerseyM54-aLX9.ttf');
}
*{
  font-family: Commissioner, sans-serif;
  font-display: swap;
  font-style: normal;
}
#app{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
.flex-col{
  display: flex;
  flex-direction: column;
}
.flex-row{
  display: flex;
  flex-direction: row;
}
.loading-spin{
  position: fixed;
  top: 0;
  left: 0;
  background: rgba( 0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  padding-top: 300px;
  z-index: 9999;
}
.firework{
    position: fixed;
    top: 0;
    left: 0;
    background: rgba( 0, 0, 0, 0.7);
    height: 100%;
    width: 100%;
    z-index: 9999;
    transition: opacity 1.2s ease-in;
    .timer{
        position: absolute;
        width: 200px;
        top: 150px;
        left: calc(50% - 100px);
        text-align: center;
        font-size: 320px;
        color: #568357;
        font-family: Jersey !important; 
    }
    .timer-btn{
        cursor: pointer !important;
        position: absolute;
        width: 320px;
        top: 280px;
        left: calc(50% - 200px);
        text-align: center;
        font-size: 60px;
        font-weight: 800;
        border: 1px solid #ffffff;
        padding: 6px 40px 10px 40px;
        border-radius: 25px;
        background: #568357;
        color: #ffffff;
    }
}
.paging{
    .pagination {
        
    }
    li{
        cursor: pointer;
        // padding: 10px 16px;
        // border: 1px solid #568357;
        background: #ffffff;
        margin: 0 6px;
        border-radius: 10px;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */

        display: flex;
        align-items: center;
        text-align: center;

        /* Gray 2 */

        color: #4F4F4F
    }
    li:first-of-type, li:last-of-type{
        padding: 10px 16px;
    }
    .active-item{
        background: rgba(51, 96, 52, 0.2);
        color: #568357;
    }
    .page-item a{
        cursor: pointer;
        padding: 10px 16px;
        border-right: none;
    }
}
.vueperslides__inner, .vueperslides__track{
    max-height: 280px !important;
}
.vueperslide__image {
    transform: scale(1);
    background-size: 320px auto !important;
    background-repeat: no-repeat;
    background-position: center;
}
.faq-answer{
    width: 100%;
    text-align: left;
    h3{
        font-weight: 500;
        font-size: 24px;
        line-height: 28px;
        letter-spacing: 0.04em;
        color: #568357;
    }
    p{
        margin-top: 10px;
        height: 50px;
        font-weight: 300;
        font-size: 18px;
        line-height: 23px;
        letter-spacing: 0.03em;
        color: #333333;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .active{
        display: flex;
        height: auto;
        transition: height 0.5s;
    }
}
.page-content{
    *{
        font-family: Commissioner !important;
        font-style: normal !important;
    }
    h5{
        margin: 0;
        text-align: left;
        position: relative;
        cursor: pointer;
        // margin-top: 20px;
        padding-left: 20px;
        margin-left: 20px;
        font-size: 24px;
        line-height: 26px;
        letter-spacing: 0.04em;
        color: #568357;
    }
    h5:before{
        content:'\00B7';
        position: absolute;
        top: -20px;
        left: 0;
        padding-top: 20px;
        font-size: 50px;
    }
    .sep-line{
        margin: 40px 0 0px 0;
        border: 1px dashed #336034;
    }
    span{
        background: none !important;
    }
    h1, h3{
        // margin-top: 30px;
        font-weight: 500;
        font-size: 34px;
        line-height: 45px;
        letter-spacing: 0.04em;
        color: #568357;
    }
    p, li{
        text-align: left;
        // text-indent: 40px;
        // margin: 6px 0 !important;
        font-weight: 300;
        font-size: 22px;
        line-height: 25px;
        letter-spacing: 0.03em;
        color: #333333;
        text-align: auto;
    }
    li, ol{
        text-align: left;
    }
    img, video{
        margin: 40px auto 20px auto;
        display: block;
        text-align: center;
        max-width: 100%;
        // max-height: 400px;
        object-fit: cover;
        height: auto;
        border-radius: 10px;
    }
    img.video-place{
        cursor: pointer;
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45));
    }
    ul, ol{
        padding-left: 0;
        li{
            margin-top: 20px;
        }
        li:first-of-type{
            margin-top: 30px;
        }
    }
    ul{
        list-style: none;
    }
    ol{
        margin-left: 26px;
    }
    ul > li::before{
        margin-right: 16px;
        font-weight: bold;
        display: inline-block;
        content: url('/media/article/dot-icon.svg');
    }
    div{
        display: flex;
        flex-direction: row;
        p,img{
            width: 46%;
        }
        p:first-of-type{
            margin-right: 8%;
        }
    }
}
@media only screen and (max-width: 1500px) {
    .vueperslides__inner, .vueperslides__track{
        max-height: 240px !important;
    }
    .vueperslide__image {
        transform: scale(1);
        background-size: 240px auto !important;
        background-repeat: no-repeat;
        background-position: center;
    }
}
@media only screen and (max-width: 1024px){
    .page-content{
        *{
            font-family: Gilroy !important;
            font-style: normal !important;
        }
        h5{
            margin: 0;
            position: relative;
            cursor: pointer;
            // margin-top: 20px;
            // padding-left: 20px;
            // margin-left: 20px;
            font-size: 22px;
            line-height: 26px;
            letter-spacing: 0.04em;
            color: #568357;
        }
        h5:before{
            content:'\00B7';
            position: absolute;
            top: -20px;
            left: 0;
            padding-top: 20px;
            font-size: 50px;
        }
        .sep-line{
            margin: 30px 0 0px 0;
            border: 1px dashed #336034;
        }
        h1, h3{
            // margin-bottom: 10px;
            // margin-top: 20px;
            font-weight: 500;
            font-size: 28px;
            line-height: 30px;
            letter-spacing: 0.04em;
            color: #568357;
        }
        p, li{
            // text-indent: 40px;
            // margin-top: 10px;
            font-weight: 300;
            font-size: 18px;
            line-height: 20px;
            letter-spacing: 0.03em;
            color: #333333;
        }
        img, video{
            margin: 30px auto 15px auto;
            // width: 100%;
            max-height: 360px;
            object-fit: cover;
            height: auto;
            border-radius: 10px;
        }
        img.video-place{
            cursor: pointer;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45));
        }
        ul, ol{
            padding-left: 0;
            li{
                margin-top: 15px;
            }
            li:first-of-type{
                margin-top: 20px;
            }
        }
        ul{
            list-style: none;
        }
        ol{
            // margin-left: 20px;
        }
        ul > li::before{
            margin-right: 16px;
            font-weight: bold;
            display: inline-block;
            content: url('/media/article/dot-icon.svg');
        }
        div{
            display: flex;
            flex-direction: row;
            p,img{
                width: 46%;
            }
            p:first-of-type{
                margin-right: 8%;
            }
        }
    }
    .vueperslides__inner, .vueperslides__track{
        max-height: 180px !important;
    }
    .vueperslide__image {
        transform: scale(1);
        background-size: 180px auto !important;
        background-repeat: no-repeat;
        background-position: center;
    }
}
@media only screen and (max-width: 720px){
    .faq-answer{
        width: 100%;
        text-align: left;
        h3{
            margin: 6px 0;
            font-weight: 500;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 0.04em;
            color: #568357;
        }
        p{
            margin: 8px 0 10px 0;
            height: 42px;
            font-weight: 300;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.03em;
            color: #333333;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .active{
            display: flex;
            height: auto;
            transition: height 0.5s;
        }
    }
    .page-content{
        *{
            font-family: Gilroy !important;
            font-style: normal !important;
        }
        h5{
            margin: 0;
            position: relative;
            cursor: pointer;
            margin-top: 20px;
            padding-left: 20px;
            margin-left: 20px;
            font-weight: 800;
            font-size: 20px;
            line-height: 22px;
            letter-spacing: 0.04em;
            color: #568357;
        }
        h5:before{
            content:'\00B7';
            position: absolute;
            top: -20px;
            left: 0;
            padding-top: 20px;
            font-size: 50px;
        }
        .sep-line{
            margin: 30px 0 0px 0;
            border: 1px dashed #336034;
        }
        h1, h3{
            
            margin-bottom: 10px;
            margin-top: 20px;
            font-weight: 800;
            font-size: 20px;
            line-height: 22px;
            letter-spacing: 0.04em;
            color: #568357;
        }
        p, li{
            // text-indent: 40px;
            margin-top: 10px;
            font-weight: 300;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.03em;
            color: #333333;
        }
        img, video{
            margin: 30px 0 15px 0;
            width: 100%;
            max-height: 320px;
            object-fit: cover;
            height: auto;
            border-radius: 10px;
        }
        img.video-place{
            cursor: pointer;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45));
        }
        ul, ol{
            padding-left: 0;
            li{
                margin-top: 15px;
            }
            li:first-of-type{
                margin-top: 20px;
            }
        }
        ul{
            list-style: none;
        }
        ol{
            margin-left: 20px;
        }
        ul > li::before{
            margin-right: 16px;
            font-weight: bold;
            display: inline-block;
            content: url('/media/article/dot-icon.svg');
        }
        div{
            display: flex;
            flex-direction: row;
            p,img{
                width: 46%;
            }
            p:first-of-type{
                margin-right: 8%;
            }
        }
    }
    .vueperslide__image {
        transform: scale(1);
        background-size: 140px auto !important;
        background-repeat: no-repeat;
        background-position: center;
    }
}
@media only screen and (max-width: 480px){
    .vueperslide__image {
        transform: scale(1);
        background-size: 100px auto !important;
        background-repeat: no-repeat;
        background-position: center;
    }
}

$particles: 50;
$width: 600;
$height: 600;

// Create the explosion...
$box-shadow: ();
$box-shadow2: ();
@for $i from 0 through $particles {
  $box-shadow: $box-shadow,
               random($width)-$width / 2 + px
               random($height)-$height / 1.2 + px
               hsl(random(360), 100, 50);
  $box-shadow2: $box-shadow2, 0 0 #fff
}
@mixin keyframes ($animationName) {
    @-webkit-keyframes #{$animationName} {
        @content;
    }

    @-moz-keyframes #{$animationName} {
        @content;
    }

    @-o-keyframes #{$animationName} {
        @content;
    }

    @-ms-keyframes #{$animationName} {
        @content;
    }

    @keyframes #{$animationName} {
        @content;
    }
}

@mixin animation-delay ($settings) {
    -moz-animation-delay: $settings;
    -webkit-animation-delay: $settings;
    -o-animation-delay: $settings;
    -ms-animation-delay: $settings;
    animation-delay: $settings;
}

@mixin animation-duration ($settings) {
    -moz-animation-duration: $settings;
    -webkit-animation-duration: $settings;
    -o-animation-duration: $settings;
    -ms-animation-duration: $settings;
    animation-duration: $settings;
}
@mixin animation ($settings) {
    -moz-animation: $settings;
    -webkit-animation: $settings;
    -o-animation: $settings;
    -ms-animation: $settings;
    animation: $settings;
}

@mixin transform ($settings) {
    transform: $settings;
    -moz-transform: $settings;
    -webkit-transform: $settings;
    -o-transform: $settings;
    -ms-transform: $settings;
}

.pyro > .before, .pyro > .after {
    z-index: 9998;
    position: absolute;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    box-shadow: $box-shadow2;
    @include animation((1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards));
}
    
.pyro > .after {
  @include animation-delay((1.25s, 1.25s, 1.25s));
  @include animation-duration((1.25s, 1.25s, 5.25s));
}
        
@include keyframes(bang) {
  to {
    box-shadow:$box-shadow;
  }
}
    
@include keyframes(gravity)  {
  to {
    @include transform(translateY(200px));
    opacity: 0;
  }
}
    
@include keyframes(position) {
  0%, 19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%, 39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%, 59.9% {  
    margin-top: 20%;
    margin-left: 70%
  }
  60%, 79.9% {  
    margin-top: 30%;
    margin-left: 20%;
  }
  80%, 99.9% {  
    margin-top: 30%;
    margin-left: 80%;
  }
}

</style>
